var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDataFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 123,
    viewBox: "0 0 138 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009557"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1211",
    opacity: 0.2,
    cx: 65.2869,
    cy: 57.2869,
    r: 57.2869,
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector 234251061"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9738 96.8051L33.1955 90.1746L37.7042 85.1355L50.6999 77.0132L58.9216 71.8746L62.6346 67.3659L74.3042 60.4703L80.139 57.0225L89.1564 70.8138L83.3216 74.4942L71.9173 81.6877L66.0825 83.279L58.1206 88.3181L45.1303 96.5399L38.2346 98.3964L32.9056 100.765L28.6868 102.64L22.852 99.9877L20.4651 101.844L18.0781 98.3964L18.8738 97.3355L20.9955 97.8659V96.8051H24.9738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9738 96.8051L33.1955 90.1746M24.9738 96.8051H20.9955V97.8659L18.8738 97.3355L18.0781 98.3964L20.4651 101.844L22.852 99.9877L28.6868 102.64M24.9738 96.8051L28.6868 102.64M33.1955 90.1746L37.7042 85.1355M33.1955 90.1746L38.2346 98.3964M37.7042 85.1355L45.1303 96.5399M37.7042 85.1355L50.6999 77.0132M58.9216 71.8746L62.6346 67.3659M58.9216 71.8746L66.0825 83.279M58.9216 71.8746L50.6999 77.0132M62.6346 67.3659L71.9172 81.6877M62.6346 67.3659L74.3042 60.4703M71.9172 81.6877L66.0825 83.279M71.9172 81.6877L83.3216 74.4942M66.0825 83.279L58.1206 88.3181M45.1303 96.5399L38.2346 98.3964M45.1303 96.5399L58.1206 88.3181M38.2346 98.3964L28.6868 102.64M74.3042 60.4703L80.139 57.0225L89.1564 70.8138L83.3216 74.4942M74.3042 60.4703L83.3216 74.4942M50.6999 77.0132L58.1206 88.3181M31.8694 98.3964L33.7259 102.64L30.5433 104.231",
    stroke: "#383434"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251065",
    d: "M37.7043 85.1357L33.1956 90.1749L38.2347 98.3966L45.1303 96.5401L37.7043 85.1357Z",
    fill: "#12D9E3",
    stroke: "#12D9E3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251064",
    d: "M62.6347 67.3643L58.9216 71.873L66.0825 83.2773L71.9173 81.686L62.6347 67.3643Z",
    fill: "#12D9E3",
    stroke: "#12D9E3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251063",
    d: "M89.1564 70.8138L80.139 57.0225L74.3042 60.4703L83.3216 74.4942L89.1564 70.8138Z",
    fill: "#12D9E3",
    stroke: "#12D9E3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 41281",
    x: 44.0696,
    y: 100.781,
    width: 6.36522,
    height: 2.65217,
    rx: 1.32609,
    fill: "#F2CA00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 41282",
    x: 45.6608,
    y: 86.9917,
    width: 3.18261,
    height: 13.7913,
    rx: 1.5913,
    fill: "white",
    stroke: "#383434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251066",
    d: "M7.46948 122H43.539",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251067",
    d: "M53.6174 122L137.426 122",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251062",
    d: "M46.4565 103.433L39.6982 120.329C39.3784 121.128 39.9673 121.998 40.8286 121.998C41.3411 121.998 41.7988 121.677 41.9733 121.195L47.2521 106.616L52.5553 121.263C52.7152 121.704 53.1346 121.998 53.6042 121.998C54.3817 121.998 54.9207 121.223 54.65 120.494L48.313 103.433H46.4565Z",
    fill: "#F2CA00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009220"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251067_2",
    d: "M112.371 71.6133V74.5298",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251068",
    d: "M110.904 73.0044H113.83",
    stroke: "#383434",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009221"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251067_3",
    d: "M29.6235 30.2354V33.1519",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251068_2",
    d: "M28.1565 31.6265H31.0822",
    stroke: "#383434",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251067_4",
    d: "M70.467 10.0796V12.9961",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251068_3",
    d: "M69 11.4707H71.9257",
    stroke: "#383434",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009223"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251067_5",
    d: "M2.04089 61V63.9165",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251068_4",
    d: "M0.573853 62.3911H3.49953",
    stroke: "#383434",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251067_6",
    d: "M129.876 28.6431V31.5596",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251068_5",
    d: "M128.409 30.0342H131.334",
    stroke: "#383434",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009225"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251067_7",
    d: "M78.4235 41.3779V44.2944",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251068_6",
    d: "M76.9564 42.769H79.8821",
    stroke: "#383434",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251067_8",
    d: "M65.6931 95.479V98.3955",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251068_7",
    d: "M64.2261 96.8701H67.1518",
    stroke: "#383434",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataFound);
export default __webpack_public_path__ + "static/media/noDataFound.71b70f1344a638da7146ac2ddf4eab96.svg";
export { ForwardRef as ReactComponent };